// The Library's Free webinars, worked out from the shown webinars' rows and the clock (Adam, 9 Oct, in
// place of the boards' next 2 and the latest replay). Pure: lib/format.js and free/webinars.js's
// replayPath only, so a test imports it.
// - upcoming: every shown webinar that hasn't ended yet (today's and 1 on now included), soonest
//   first, each opening its own card on Free webinars (/free-webinars#webinar-<id>);
// - replays: every shown webinar that has ended with its replay up, newest first, however many,
//   each opening its own page, where it plays (/free-webinars/replay/<id>; Adam, 23 Oct);
// - thumbnails: whether any of them has Adam's own thumbnail (thumbnail_path). With none, Coming up
//   keeps its compact cards; Watch again's are always 16:9.
// accentFor(row) gives the dot's colour key (what the webinar sells), gold ('master') by default.
import * as f from '../lib/format.js'
import { replayPath } from '../free/webinars.js'

const MIN = 60e3

export function webinarCards(rows, nowMs, { accentFor = () => 'master' } = {}) {
  const shown = (rows || []).filter(w => w.shown).map(w => {
    const start = Date.parse(w.starts_at)
    return { ...w, start, end: start + w.duration_minutes * MIN }
  })
  const card = (w, replay) => {
    const live = !replay && w.start <= nowMs && nowMs < w.end
    return {
      id: w.id, block: f.dateBlock(w.start), date: f.shortDate(w.start), title: w.title,
      accent: accentFor(w) || 'master',
      kind: replay ? 'Replay' : live ? 'Live on Zoom now' : `Live on Zoom, ${f.time(w.start)}`,
      action: replay ? 'Watch the replay' : 'Register on Zoom',
      href: replay ? replayPath(w.id) : `/free-webinars#webinar-${w.id}`,
      thumbnailPath: w.thumbnail_path || null,
    }
  }
  const upcoming = shown.filter(w => w.end > nowMs).sort((a, b) => a.start - b.start).map(w => card(w, false))
  const replays = shown.filter(w => w.replay_up && w.end <= nowMs).sort((a, b) => b.start - a.start).map(w => card(w, true))
  return { upcoming, replays, thumbnails: [...upcoming, ...replays].some(w => w.thumbnailPath) }
}
